export default __webpack_public_path__ + "static/media/timeseries.81eb1247.svg";